import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "main_frame" }

import { onMounted } from "vue";
import store from "./store";
import { loadTranslations } from "@/composables/useTranslation";
import { loadProtocolText } from "@/composables/useProtocolText";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(async () => {
  await store.dispatch("auth/verifyToken");
  // 加载翻译表到内存缓存（设备名英文转中文展示用）
  loadTranslations();
  // 加载协议 TEXT 枚举映射到内存缓存（工况/电池状态等枚举值翻译用）
  loadProtocolText();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view)
  ]))
}
}

})